export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            currentStep: 0,
            showTour: false,
            maskClosable: true,
            tourData: [
                {
                    target: '#maskDemo1',
                    title: '遮罩层交互',
                    content: '当maskClosable为true时，点击遮罩层可关闭引导',
                    position: 'bottom'
                },
                {
                    target: '#maskDemo2',
                    title: '禁用遮罩层关闭',
                    content: '当maskClosable为false时，点击遮罩层无反应，必须使用按钮进行操作',
                    position: 'right'
                }
            ]
        };
    }

    @bind
    startTour() {
        this.set({
            showTour: true,
            currentStep: 0
        });
    }

    @bind
    finishTour() {
        this.set({
            showTour: false
        });
    }
}